export enum PH_TYPE {
  ACIDIC = "ACIDIC",
  NEUTRAL = "NEUTRAL",
  ALKALINE = "ALKALINE",
}

export enum SOIL_TYPE {
  HEAVY = "HEAVY",
  MEDIUM = "MEDIUM",
  LIGHT = "LIGHT",
}

export enum INVESTMENT_LEVEL {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export type MainCropsPreferencesRequest = {
  mainCropId: string;
  seedingDate: string;
  harvestDate: string;
  year: number;
};

export type CoverCropDetailsData = {
  growingPeriod: boolean;
  rotationCategory: boolean;
  minGrowthPeriod: boolean;
  matchCrop: boolean;
  nitrogen: boolean;
  fodder: boolean;
  biogas: boolean;
  costCategory: boolean;
  droughtProne: boolean;
  soilPh: boolean;
  soilType: boolean;
};

export type CoverCropWithScores = {
  coverCropId: string;
  coverCropName: string;
  coverCropScore: number;
  coverCropDetails: CoverCropDetailsData;
};

export type MainCropsResponse = MainCropsPreferencesRequest & {
  mainCropName: string;
};

export type MainCropOption = {
  id: string;
  name: string;
  calWeekSeeding: number;
  calWeekHarvesting: number;
  seasonId: number;
};

export type CropRecommendationResponsePreference = {
  isDrought: boolean | null;
  pHType: PH_TYPE | null;
  soilType: SOIL_TYPE | null;
  legumeBreaksYears: number | null;
  investmentLevel: INVESTMENT_LEVEL | null;
  isFodder: boolean | null;
  isBiogas: boolean | null;
  mainCropsNumber: number | null;
};

export type CropRecommendation = {
  mainCrop: MainCropsResponse;
  nitrogenNeed: boolean;
  coverCropsWithScores: CoverCropWithScores[];
};

export type CropRecommendationResponse = {
  id: string;
  preferences: CropRecommendationResponsePreference;
  cropRecommendations: CropRecommendation[];
};

export type CropRecommendationParametersRequest = {
  settingsPreferences: Partial<CropRecommendationResponsePreference>;
  mainCropsPreferences: Omit<MainCropsPreferencesRequest, "preferenceId">[];
};

export type UpdateDigitalAgronomistMainCropRequest = {
  preferenceId: string;
  year: number;
  requestBody: Omit<MainCropsPreferencesRequest, "year">;
};

export enum MAIN_CROP_CREATION_MODAL_TYPE {
  ADD = "ADD",
  UPDATE = "UPDATE",
}
